/* eslint-disable */

import PageScrollHandler from '../polyfills/intersection-observable';

function funcName(element) {
  element.classList.add('on-screen');
}

function loadLazyImages() {
  const containerAnimate = document.querySelectorAll('.js-container-animate');
  const lazyBg = document.querySelectorAll('.js-lazy-bg');
  const lazyImage = document.querySelectorAll('.js-lazy-img');
  console.log('load images working');
  if (lazyBg !== null && lazyBg.length > 0) {
    Array.forEach(lazyBg, element => {
      PageScrollHandler.registerBackgroundImageElement(element);
    });
  }

  if (lazyImage !== null && lazyImage.length > 0) {
    Array.forEach(lazyImage, element => {
      PageScrollHandler.registerImageElement(element);
    });
  }

  if (containerAnimate !== null) {
    Array.forEach(containerAnimate, element => {
      PageScrollHandler.registerNewElement(element, funcName, true);
    });
  }
}
Sys.WebForms.PageRequestManager.getInstance().add_endRequest(endRequest);

function endRequest(sender, args) {
  window.loadLazyImages();
}
loadLazyImages();
window.loadLazyImages = loadLazyImages;
